import React from 'react';
import InfoValueCard from "../../../../components/card/InfoValueCard";
import {red500} from "../../../../assets/jss/main";

FakeProductListStats.propTypes = {};

const BoxIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b4ef8" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round">
        <path
            d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
        <line x1="12" y1="22.08" x2="12" y2="12"/>
    </svg>
);

const CopyIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b4ef8" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2"/>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
);

const WarningIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b4ef8" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
);

const BarChartIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b4ef8" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round">
        <line x1="3" y1="20" x2="21" y2="20"/>
        <line x1="3" y1="20" x2="3" y2="4"/>
        <rect x="6" y="14" width="3" height="6" rx="1"/>
        <rect x="11" y="9" width="3" height="11" rx="1"/>
        <rect x="16" y="11" width="3" height="9" rx="1"/>
    </svg>
);

const TrendingUpIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b4ef8" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round">
        <polyline points="3 17 9 11 13 15 21 7"/>
        <polyline points="15 7 21 7 21 13"/>
    </svg>
);

const TargetIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b4ef8" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="6"/>
        <circle cx="12" cy="12" r="2"/>
    </svg>
);

const StarIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b4ef8" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
);

// Wrapper optionnel
const IconWrapper = ({children}) => (
    <div style={{
        width: "56px",
        height: "56px",
        borderRadius: "16px",
        backgroundColor: "#eef0fd",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }}>
        {children}
    </div>
);

function FakeProductListStats({total}) {

    if (!total) {
        return;
    }

    const firstNumber = total.toString()[0];

    const tauxattr = (value, max = total, min = 65, max_pct = 80) => {
        const raw = (value / max) * 100;
        return Math.round(Math.min(max_pct, Math.max(min, raw)));
    };

    const tauxrtra = (value, max = total, min = 20, max_pct = 45) => {
        const raw = (value / max) * 100;
        return Math.round(Math.min(max_pct, Math.max(min, raw)));
    };

    const score = (value, max = total, min = 70, max_pct = 90) => {
        const raw = (value / max) * 100;
        return Math.round(Math.min(max_pct, Math.max(min, raw)));
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '12px',
            marginBottom: '24px'
        }}>
            <InfoValueCard
                value={Math.round(total * 0.80)}
                label={'enrichis & publiés'}
                icon={<BoxIcon/>}
                subtext={(
                    <span style={{
                        color: '#22c55e',
                        fontSize: '12px'
                    }}>
                    +{firstNumber}% vs dernier import
                    </span>
                )}
            />
            <InfoValueCard
                value={Math.round(total * 0.10)}
                label={'Doublons détectés'}
                icon={<CopyIcon/>}
                subtext={(Math.round(total * 0.10) > 0 && (
                    <span style={{
                        color: red500,
                        fontSize: '12px'
                    }}>
                        -{Math.round(parseInt(firstNumber) + 1).toFixed(2)}% vs dernier import
                    </span>
                ))}
            />
            <InfoValueCard
                value={Math.round(total * 0.05)}
                label={'Anomalies'}
                icon={<WarningIcon/>}
            />
            <InfoValueCard
                value={`${tauxattr(total)}%`}
                label={'Taux attr. initiaux'}
                icon={<BarChartIcon/>}
            />
            <InfoValueCard
                value={`${tauxrtra(total)}%`}
                label={'Taux retravaillé'}
                icon={<TrendingUpIcon/>}
            />
            <InfoValueCard
                value={Math.round(total * 0.12)}
                label={'Attr. manquants'}
                icon={<TargetIcon/>}
                subtext={(
                    <span style={{
                        color: red500,
                        fontSize: '12px'
                    }}>
                        -{Math.round(parseInt(firstNumber) + 2).toFixed(2)}% vs dernier import
                    </span>
                )}
            />
            <InfoValueCard
                value={`${score(total)}/100`}
                label={'Score qualité'}
                icon={<StarIcon/>}
            />
        </div>
    );
}

export default FakeProductListStats;
